import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileCSVOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 13h-1V9.843a2 2 0 0 0-.584-1.412l-5.824-5.843A2 2 0 0 0 19.175 2H7a2 2 0 0 0-2 2v9H4a2.006 2.006 0 0 0-2 2v9a2.006 2.006 0 0 0 2 2h1v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2h1a2.006 2.006 0 0 0 2-2v-9a2.006 2.006 0 0 0-2-2m-8-8.173L24.16 9H20ZM7 4h11v5a2.006 2.006 0 0 0 2 2h5v2H7Zm18 24H7v-2h18Zm3-4H4v-9h24Z" />
    <path d="M9.842 22.3c1.493 0 2.34-.87 2.34-1.84v-.116h-1.196a1.004 1.004 0 0 1-1.123 1.007c-.757 0-1.239-.48-1.239-1.507v-.602c0-1.023.486-1.527 1.232-1.527a1.047 1.047 0 0 1 1.13 1.055h1.197v-.113c0-1.031-.882-1.89-2.336-1.89a2.274 2.274 0 0 0-2.488 2.472v.601a2.26 2.26 0 0 0 2.483 2.46m5.909-.886c-.744 0-1.136-.352-1.17-.746h-1.196c.017.754.576 1.633 2.306 1.633 1.454 0 2.354-.645 2.354-1.692 0-.968-.728-1.347-1.588-1.515l-.89-.18c-.526-.098-.801-.305-.801-.614 0-.41.375-.668.977-.668.68 0 1.02.348 1.05.723h1.161c-.012-.941-.894-1.598-2.207-1.598-1.243 0-2.224.582-2.224 1.63 0 .906.688 1.327 1.514 1.488l.882.183c.594.121.896.297.896.66 0 .415-.37.696-1.064.696m6.707.785 1.919-5.332h-1.382l-1.239 4.078h-.051l-1.257-4.078h-1.441l1.931 5.332z" />
  </svg>
);
const ForwardRef = forwardRef(IconFileCSVOutlineSVG);
ForwardRef.displayName = "IconFileCSVOutline";
export { ForwardRef as IconFileCSVOutline };
